import { render, staticRenderFns } from "./CustomerMediaRow.vue?vue&type=template&id=3d0627f1&scoped=true"
import script from "./CustomerMediaRow.vue?vue&type=script&lang=js"
export * from "./CustomerMediaRow.vue?vue&type=script&lang=js"
import style0 from "./CustomerMediaRow.vue?vue&type=style&index=0&id=3d0627f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0627f1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductVideoPreview: require('/app/components/ProductVideoPreview.vue').default})
